import type { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { client } from '../common';
import type { Reservation } from './types';

type Variables = {
  id: number;
  signature: string;
  credits: number;
  publicToken?: string;
};
export type FinalizeReservation = {
  data: Reservation;
};

export const useFinalizeReservation = createMutation<
  FinalizeReservation,
  Variables,
  AxiosError
>({
  mutationFn: async (variables) =>
    client({
      url: `v2/reservations/${variables.id}/finalize`,
      method: 'POST',
      params: variables.publicToken
        ? { public_token: variables.publicToken }
        : undefined,
      data: {
        signature: variables.signature,
        credits: variables.credits,
      },
    })
      .then((response) => response.data)
      .catch((err: any) => {
        console.error('yoyo', err);
        throw new Error(err.response.data.errors.join(', '));
      }),
});
